import { CampaignMonitorServiceApiFactory } from '@layup/api-sdk';
import { createLayupClient } from './layupApiClient';

export const campaignMonitorClient = () => {
  const client = createLayupClient();
  return CampaignMonitorServiceApiFactory(undefined, undefined, client);
};

export const subscribe = async (email: string, listType: 'shopper' | 'business') => {
  const response = await campaignMonitorClient().campaignMonitorServiceSubscribe({
    email: email,
    type: listType || 'shopper',
  });

  if (!response.data?.success) {
    throw new Error('Failed to subscribe to newsletter');
  }

  return response.data;
};
